// extracted by mini-css-extract-plugin
export default {"card":"imgCard_card__8azDe","image":"imgCard_image__WI2mx"};